import axios from "axios";

//IMPORT API ROUTE URL
import { REMOVE_CERTIFICATION_ROUTE } from "./apiRoutes";

const removeCertificate = (resource_slug, certification_id) => {
  var postData = new FormData();

  postData.append("certification_id", certification_id);
  postData.append("resource_slug", resource_slug);

  return axios
    .post(REMOVE_CERTIFICATION_ROUTE, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default removeCertificate;
